import { createSelector } from 'reselect';

const uiSelector = state => state.ui;
const metaSelector = state => state.meta;
const routingSelector = state => state.routing;
const userPermissionsSelector = state => state.ustate.perms;
const widgetSelector = state => state.widgetState;

export default createSelector(
	[ uiSelector, metaSelector, routingSelector, userPermissionsSelector, widgetSelector ],
	( ui, meta, routing, userPermissions, widget ) => {
		return {
			widgetState: widget,
			ui: {
				headerOverflowOpened: ui.headerOverflowOpened,
				sidebarOpened: ui.sidebarOpened
			},
			...meta,
			userPermissions,
			routing
		};
	}
);



// WEBPACK FOOTER //
// ./src/selectors/headerSelector.js